import { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, vars } from '@etg/wings';
import { css, resetButtonStyle, mediaQueries } from '@eti/styles';
import { ConnectedComboBox } from '@eti/form';
import { useTranslation } from '@eti/providers';
import { DangerousHtmlContent } from '@eti/components';
import { useProductSnowplowTracking } from '../../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const dropDownWrapperStyles = css`
  max-width: 300px;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    width: 300px;
  }
`;
const inputWrapperStyles = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  margin-left: 35px;
  margin-top: 12px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 35px;
  }

  @media ${mediaQueries.medium.up} {
    align-items: center;
    flex-direction: row;
  }
`;
const readMoreStyles = css`
  color: ${vars.colors.links.default};
  font-size: 0.75rem;
  ${resetButtonStyle};

  @media ${mediaQueries.medium.up} {
    margin-left: 10px;

    [dir='rtl'] & {
      margin-left: 0;
      margin-right: 10px;
    }
  }
`;
const ManulifeProvince = _ref => {
  let {
    productName,
    options
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    sendClickEvent
  } = useProductSnowplowTracking(productName);
  const normalizeProvince = option => option !== null && option !== void 0 ? option : '';
  const handleOnReadMoreClick = () => {
    setIsModalOpen(true);
    sendClickEvent({
      property: 'Why do you need to state your province?'
    });
  };
  const handleOnModalClose = () => {
    setIsModalOpen(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: inputWrapperStyles,
    children: [/*#__PURE__*/_jsx("div", {
      className: dropDownWrapperStyles,
      children: /*#__PURE__*/_jsx(ConnectedComboBox, {
        "data-testid": `${productName}-province`,
        label: t('Manulife.Province.Label'),
        name: `${productName}.province`,
        normalize: normalizeProvince,
        options: options,
        placeholder: t('Manulife.Province.Placeholder')
      })
    }), /*#__PURE__*/_jsx("button", {
      className: readMoreStyles,
      onClick: handleOnReadMoreClick,
      type: "button",
      children: t('Manulife.Province.ReadMore.Text')
    }), /*#__PURE__*/_jsx(Dialog, {
      closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
      isOpen: isModalOpen,
      onDismiss: handleOnModalClose,
      title: t('Manulife.Province.Modal.Title'),
      children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
        content: t('Manulife.Province.Modal.Content')
      })
    })]
  });
};
ManulifeProvince.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  productName: PropTypes.string
};
export default ManulifeProvince;
//# sourceMappingURL=ManulifeProvince.js.map